const MAX_POST_LENGTH = 1500; // get stream limitation/requirement

const MAX_COMMENT_LENGTH = 1500; // get stream limitation/requirement

export {
    MAX_POST_LENGTH,
    MAX_COMMENT_LENGTH,
}
